<app-loading-spinner label="Logging out"></app-loading-spinner>

